"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStep = exports.StyledStepper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
exports.StyledStepper = styled_components_1.default.div `
    width: 100%;
    text-align: center;
`;
exports.StyledStep = styled_components_1.default.span `
    display: inline-block;
    height: ${tokens_1.SIZES[1]};
    width: ${tokens_1.SIZES[5]};
    border-radius: ${tokens_1.BORDERS.radius};
    background-color: ${tokens_1.COLOURS.greyscale.silver};
    margin: 0 ${tokens_1.SIZES[0.5]};

    ${({ active }) => active && `background-color: ${tokens_1.COLOURS.primary.blue["100"]};`}
`;
//# sourceMappingURL=Stepper.styles.js.map